import elementExists from "../utils/element-exists";
import eventBus from "../services/event-bus";
import QuantityComponent from "./quantity";

/**
 * Cart
 * Cart Display
 * Initializes line item remove + quantity updates
 * Listes for removed and quantity updates
 **/
Shopify.theme = Shopify.theme || {};

const Cart = function (container) {
  const classes = {
    cartEmpty: 'empty'
  };

  const selectors = {
    cartItem: '[data-cart-item]',
    cartRemove: '[data-cart-remove]',
    cartCount: '[data-cart-count]',
    cartSubTotal: '[data-cart-subtotal]',
    cartAjaxContainer: '[data-ajax-container]'
  }

  const attributes = {
    sideBarCart: 'data-sidebar-cart',
    cartItemIndex: 'data-cart-item-index',
    cartItemKey: 'data-cart-item-key',
    cartItemQuantity: 'data-cart-item-quantity',
    cartItemTitle: 'data-cart-item-title',
    cartItemUrl: 'data-cart-item-url',
    quantityItem: 'data-quantity-item'
  };

  let removeButtons = container.querySelectorAll(selectors.cartRemove);
  let cartCount = container.querySelector(selectors.cartCount);
  let cartSubTotal = container.querySelector(selectors.cartSubTotal);
  let cartAjaxContainer = container.querySelector(selectors.cartAjaxContainer);

  const init = () => {
    eventBus.on(eventBus.types.CartUpdated, onCartUpdated);
    eventBus.on(eventBus.types.QuantityUpdated, onQuantityUpdated);

    if (elementExists(removeButtons, true)) {
      removeButtons.forEach(btn => {
        btn.addEventListener('click', removeItem);
      })
    }
  }

  // fadeOut takes an element and increases the opacity until it fades out
  const fadeOut = function (elm) {
    const fadeEffect = setInterval(function () {
      if (!elm.style.opacity) {
        elm.style.opacity = 1;
      }
      if (elm.style.opacity > -0.3) {
        elm.style.opacity -= 0.1;
      } else {
        clearInterval(fadeEffect);
        elm.remove();
      }
    }, 30);
  }

  const removeItem = (e) => {
    e.preventDefault();
    const elm = e.target.closest(selectors.cartItem);
    const key = elm.getAttribute(attributes.cartItemKey);

    Shopify.cartService.removeItem(key).then(function (response) {
      if (response.success) {
        fadeOut(elm);
      }
    });
  }

  const updateCart = () => {
    container.querySelector('[data-cart-line-items]').innerHTML = '';

    Shopify.cartService.cart.items.forEach((product, i) => {
      let template = document.querySelector('#cart-drawer-product');
      let renderableTemplate = template.content.cloneNode(true);
      let cartRow = renderableTemplate.querySelector('.cart__row');
      let cartImage = renderableTemplate.querySelector('.cart__image');
      let productPrice = renderableTemplate.querySelector('[data-cart-item-regular-price]');
      let productTitle = renderableTemplate.querySelector('.cart__product-title');
      let quantityInput = renderableTemplate.querySelector('.product-form__qty-input');
      let removeText = renderableTemplate.querySelector('.text-link--accent');

      cartRow.setAttribute('data-cart-item-key', product['key']);
      cartRow.setAttribute('data-cart-item-url', product['url']);
      cartRow.setAttribute('data-cart-item-title', product['title']);
      cartRow.setAttribute('data-cart-item-index', i);
      cartRow.setAttribute('data-cart-item-quantity', product['quantity']);
      cartImage.setAttribute('src', product['image']);
      cartImage.setAttribute('alt', product['title']);
      productPrice.innerHTML = `${Shopify.formatMoney(product.final_price)}`;
      productTitle.setAttribute('href', product['url']);
      productTitle.innerHTML = product['title'];
      quantityInput.setAttribute('id', `Quantity-${product['id']}`);
      quantityInput.setAttribute('value', product['quantity']);
      removeText.setAttribute('aria-label', `Remove ${product['title']}`);

      container.querySelector('[data-cart-line-items]').appendChild(renderableTemplate);
    });

    // update event listeners
    removeButtons = container.querySelectorAll('[data-cart-remove]');
    removeButtons.forEach(btn => {
      btn.addEventListener('click', removeItem);
    });

    let quantitiyButtons = container.querySelectorAll('[sh-quantity-component]');

    quantitiyButtons.forEach(btn => {
      let quantityComponent = new QuantityComponent(btn);
    });
  }


  const onQuantityUpdated = (e) => {
    e.preventDefault();
    const elm = e.detail.target.closest(selectors.cartItem);
    let key = '';

    if (elm) {
      key = elm.getAttribute(attributes.cartItemKey);
    }

    // if we have a valid element and key (ie: we're on the cart), update the quantity in cart
    if (elm && key) {
      Shopify.cartService.updateQuantity(key, e.detail.value).then(function (res) {
        const editedItems = document.querySelectorAll(`[data-cart-item-key='${key}']`);
        // get the recently updated values
        if (res.cart.items) {
          res.cart.items.forEach(item => {
            if (item.key == key) {
              editedItems.forEach(editedElm => {
                editedElm.querySelector('.product-form__qty-input').value = item.quantity;
              });
            }
          });
        }

        if (res.success && e.detail.value == 0) {
          fadeOut(elm);
        }
      });
    }
  };


  const onCartUpdated = (cart) => {
    // the cart is empty just hide it.
    if (Shopify.cartService.cart.item_count == 0) {
      container.classList.add(classes.cartEmpty);
      return;
    } else {
      container.classList.remove(classes.cartEmpty);
    }

    // update the cart count
    if (Shopify.cartService.cart.item_count == 1) {
      cartCount.innerText = Shopify.cartService.cart.item_count + ' Item';
    } else {
      cartCount.innerText = Shopify.cartService.cart.item_count + ' Items';
    }

    // update the subtotal
    if (cartSubTotal) {
      cartSubTotal.innerText = Shopify.formatMoney(Shopify.cartService.cart.total_price);
    }

    // update the cart visual
    updateCart();

  }

  init();
}

export default Cart;
